import { createLazyFileRoute } from "@tanstack/react-router";

import { EditClientPage } from "@/features/admin/routes/ClientEdit";

export const Route = createLazyFileRoute("/_auth/admin/clients/$id/edit")({
  component: () => {
    const params = Route.useParams();
    return <EditClientPage {...params} />;
  },
});
